import React from 'react';
import { Pagination } from 'rsuite';

const PaginationComponent = ({
  total,
  limit,
  activePage,
  onChangePage,
  onChangeLimit,
  limitOptions = [10, 20, 30, 50, 100],
  className = '',
  showTotal = true,
  showLimit = true,
  showPager = true,
  showSkip = true,
  showFirstLast = true,
  showEllipsis = false,
  showBoundaryLinks = false,
  size = 'md'
}) => {
  // Build layout array based on what we want to show
  const layout = [];
  
  if (showTotal) layout.push('total');
  if (showLimit) layout.push('-');
  if (showLimit) layout.push('limit');
  if (showPager) layout.push('|');
  if (showPager) layout.push('pager');
  if (showSkip) layout.push('skip');

  return (
    <div className={`custom-pagination ${className}`}>
      <Pagination
        layout={layout}
        total={total}
        limit={limit}
        limitOptions={limitOptions}
        activePage={activePage}
        onChangePage={onChangePage}
        onChangeLimit={onChangeLimit}
        prev
        next
        first={showFirstLast}
        last={showFirstLast}
        ellipsis={showEllipsis}
        boundaryLinks={showBoundaryLinks}
        maxButtons={3}
        size={size}
      />
    </div>
  );
};

export default PaginationComponent;
